/* ==========================================================================
   Brazos Site Supply - collection cards / compare switch
   --------------------------------------------------------------------------
   Both views are rendered server-side from the same product loop, so the
   switch costs no request, no skeleton and no layout shift. The Section
   Rendering API is not involved and does not need to be.

   THE MORPH
     Each product carries a matching view-transition-name on its card and on
     its row, so the browser animates card -> row per product rather than
     cross-fading the page. A name must be unique among RENDERED elements; the
     inactive pane is [hidden] (display:none), so the pair never collides.
     Browsers without the API get an instant swap, which is also what everyone
     gets under prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.bssInit) return;
    root.dataset.bssInit = '1';

    var sw    = root.querySelector('.bssc__switch');
    var cards = root.querySelector('[data-pane="cards"]');
    var table = root.querySelector('[data-pane="table"]');
    var tbody = root.querySelector('.bssc__table tbody');
    var tray  = root.querySelector('.bssc__tray');
    if (!sw || !cards || !table || !tbody) return;

    /* ---- the switch --------------------------------------------------- */
    function setView(v) {
      function apply() {
        sw.dataset.v = v;
        Array.prototype.forEach.call(sw.querySelectorAll('button'), function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.view === v));
        });
        cards.hidden = v !== 'cards';
        table.hidden = v !== 'table';
        updateTray();
      }
      if (document.startViewTransition && !REDUCED) document.startViewTransition(apply);
      else apply();
      try { sessionStorage.setItem('bssc-view', v); } catch (e) { /* private mode */ }
    }

    sw.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-view]');
      if (b) setView(b.dataset.view);
    });

    /* A procurement buyer who switched to compare stays in compare when they
       come back from a product page. */
    try {
      if (sessionStorage.getItem('bssc-view') === 'table') setView('table');
    } catch (e) { /* private mode */ }

    /* ---- sorting -------------------------------------------------------
       Sorts the rows already on the page. Rows with no value sink to the
       bottom in BOTH directions: a missing crate weight is not a light one,
       and sorting it to the top of "lightest first" would be a lie. */
    var sortKey = null, dir = 1;
    Array.prototype.forEach.call(root.querySelectorAll('.bssc__table th[data-sort]'), function (th) {
      th.setAttribute('tabindex', '0');
      th.setAttribute('role', 'columnheader');

      function sort() {
        var k = th.dataset.sort;
        if (sortKey === k) dir = -dir; else { sortKey = k; dir = 1; }
        Array.prototype.forEach.call(root.querySelectorAll('.bssc__table th[data-sort]'), function (o) {
          o.removeAttribute('aria-sort');
        });
        th.setAttribute('aria-sort', dir === 1 ? 'ascending' : 'descending');

        var rows = Array.prototype.slice.call(tbody.rows);
        rows.sort(function (a, b) {
          var x = a.dataset[k], y = b.dataset[k];
          var xe = (x === '' || x == null), ye = (y === '' || y == null);
          if (xe && ye) return 0;
          if (xe) return 1;
          if (ye) return -1;
          var nx = parseFloat(x), ny = parseFloat(y);
          if (!isNaN(nx) && !isNaN(ny)) return dir * (nx - ny);
          return dir * String(x).localeCompare(String(y));
        });
        rows.forEach(function (r) { tbody.appendChild(r); });
      }

      th.addEventListener('click', sort);
      th.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sort(); }
      });
    });

    /* ---- the quote basket ----------------------------------------------
       This is the reason the compare mode exists: it turns a comparison into
       a project quote. The running weight is shown because 700 lb is the
       checkout ceiling - telling a buyer here is much cheaper than telling
       them at checkout. */
    function updateTray() {
      if (!tray) return;
      var picked = Array.prototype.filter.call(tbody.querySelectorAll('.bssc__pick'),
        function (c) { return c.checked; });
      var show = picked.length > 0 && !table.hidden;
      tray.hidden = !show;
      if (!show) return;

      var cents = 0, lb = 0, unweighed = 0;
      picked.forEach(function (c) {
        var tr = c.closest('tr');
        cents += parseFloat(tr.dataset.price || 0);
        if (tr.dataset.lb) lb += parseFloat(tr.dataset.lb); else unweighed++;
      });

      root.querySelector('.bssc__tray-n').textContent =
        picked.length + (picked.length === 1 ? ' model selected' : ' models selected');

      var money = '$' + Math.round(cents / 100).toLocaleString('en-US');
      var weight = unweighed
        ? Math.round(lb) + ' lb plus ' + unweighed + ' not yet weighed'
        : Math.round(lb) + ' lb';
      var note = (lb > 700 || unweighed)
        ? 'over the checkout weight ceiling, so this quotes by hand'
        : 'inside the checkout weight ceiling';
      root.querySelector('.bssc__tray-sum').textContent =
        money + ' of product · ' + weight + ' · ' + note;
    }

    tbody.addEventListener('change', function (e) {
      var cb = e.target.closest('.bssc__pick');
      if (!cb) return;
      cb.closest('tr').classList.toggle('is-picked', cb.checked);
      updateTray();
    });

    var go = root.querySelector('.bssc__tray-go');
    if (go) {
      go.addEventListener('click', function () {
        var ids = Array.prototype.filter.call(tbody.querySelectorAll('.bssc__pick'),
          function (c) { return c.checked; }).map(function (c) { return c.value; });
        if (ids.length) {
          try { sessionStorage.setItem('bss-quote-basket', JSON.stringify(ids)); } catch (e) {}
        }
      });
    }

    /* ---- facets --------------------------------------------------------
       Filtering stays Shopify-native so Search & Discovery keeps working;
       this only restyles the controls and submits on change. */
    var form = root.querySelector('.bssc__filters');
    if (form) {
      form.addEventListener('change', function () {
        window.location.search = new URLSearchParams(new FormData(form)).toString();
      });
    }
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bss-collection]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
